var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h2',[_vm._v("Agregar Banco")]),_c('v-select',{attrs:{"items":_vm.bankNames,"label":"Banco"}}),_c('v-text-field',{attrs:{"label":"Numero de Cuenta"}}),_c('v-text-field',{attrs:{"label":"Nombre"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }